import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  ScheduledNotificationsRequest,
  CreateScheduledNotificationRequest,
  UpdateScheduledNotificationRequest,
  DeleteScheduledNotificationsRequest,
  ScheduledNotificationResponse,
} from "../types/api/notifications";

const path = `/notifications/admin/${process.env.REACT_APP_API_VERSION}/scheduled`;

// Запланированные уведомления - Получить список
export function fetchScheduledNotifications(
  params: ScheduledNotificationsRequest
) {
  return mainAPI
    .get<ScheduledNotificationResponse[]>(`${path}`, {
      params,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Запланированные уведомления - Создать
export function createScheduledNotification(
  data: CreateScheduledNotificationRequest
) {
  return mainAPI.post(`${path}`, data).then(
    (res) => {
      return Promise.resolve(res.data as ScheduledNotificationResponse);
    },
    (error) => handleApiError(error)
  );
}

// Запланированные уведомления - Изменить
export function updateScheduledNotification(
  notificationId: string,
  data: UpdateScheduledNotificationRequest
) {
  return mainAPI.put(`${path}/${notificationId}`, data).then(
    (res) => {
      return Promise.resolve(res.data as ScheduledNotificationResponse);
    },
    (error) => handleApiError(error)
  );
}

// Запланированные уведомления - Отправить
export function sendScheduledNotification(notificationId: string) {
  return mainAPI.post(`${path}/${notificationId}/send`).then(
    (res) => {
      return Promise.resolve(res.data as ScheduledNotificationResponse);
    },
    (error) => handleApiError(error)
  );
}

// Запланированные уведомления - Удалить
export function deleteScheduledNotifications(
  data: DeleteScheduledNotificationsRequest
) {
  return mainAPI.post(`${path}/delete`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
